import { useTranslation } from "react-i18next"

import BasicButton from "@/components/button/BasicButton"
import Icon from "@/components/icon/Icon"
import Tab from "@/components/tab/Tab"
import { SyntheticEvent } from "react"
import { TabItemType } from "@/types/components/tab"

import "./PlayerGroupTabs.scss"

export default function PlayerGroupTabs({
  tabList,
  tabIndex,
  handleDialog,
  handleChange,
}: {
  tabList: TabItemType[]
  tabIndex: number
  handleDialog: () => void
  handleChange: (event: SyntheticEvent<Element, Event>, newTabIndex: string | number) => void
}) {
  const { t } = useTranslation()

  return (
    <>
      <Tab
        type="line"
        list={tabList}
        value={tabIndex}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        onChange={handleChange}
        className="PlayerGroupTabsCont"
      />
      <div className="Tab-Button">
        <BasicButton size="sm" type="default-outlined" className="New-Group" onClick={handleDialog}>
          <Icon type="add" size={16} />
          {t("button.newGroup")}
        </BasicButton>
      </div>
    </>
  )
}
